<template>
  <div :class="$style.wrapper">
    <div :class="$style.table">
      <div class="d-flex justify-content-between mb-2">
        <h6>選擇項目</h6>
      </div>
      <div :class="$style.linkDivDisplay">
        <div v-for="(item, index) in linkArr" :key="index" class="linkDiv" @click="submitToLink(item)">
          {{ item['name'] }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CategoryToLink',
  components: {},
  mixins: [],
  props: {},
  data() {
    return {
      linkArr: [
        {
          key: 'goods',
          name: '商品購買',
        },
        {
          key: 'service',
          name: '服務預約',
        },
        {
          key: 'prepaid',
          name: '方案購買',
        },
        {
          key: 'deposit',
          name: '儲值點數',
        },
        {
          key: 'container',
          name: '目前總訂單',
        },
      ],
    }
  },
  provide() {},
  inject: [],
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    /**
     * @description 把要做的動作傳出去
     */
    submitToLink(item) {
      this.$emit('emitToLink', item)
    },
  },
}
</script>

<style lang="scss" module>
.wrapper {
  position: relative;
  height: 100%;
}

.table {
  padding: 20px 30px 0;
  display: flex;
  flex-direction: column;
  height: 100%;

  @include touch {
    padding-bottom: 30px;
  }

  @include max-md {
    padding: 20px;
  }
}

.linkDivDisplay {
  display: flex;
  flex-wrap: wrap;

  :global {
    .linkDiv {
      flex: 1;
      /* 自動平均分配寬度 */
      max-width: calc(50% - 20px);
      /* 50% 寬度减去 padding */
      min-width: calc(50% - 20px);
      /* 50% 寬度减去 padding */
      height: 175px;
      border: 1px solid #ccc;
      padding: 10px;
      border-radius: $border-radius;
      text-align: center;
      margin: 10px;
    }
  }
}
</style>
